import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authSlice, { AuthState } from "./features/authSlice";
import historyRouteSlice, { IHistorySlice } from "./features/historyRouteSlice";
import organizationSlice, { IOrganizationSlice } from "./features/organization";
import paymentSlice, { IPaymentSlice } from "./features/paymentSlice";
import postSlice, { IPostSlice } from "./features/postSlice";
import powerBiSlice, { IPowerBiSlice } from "./features/powerBiSlice";
import reportSlice, { IReportSlice } from "./features/reportSlice";
import settingSlice, { SettingState } from "./features/settingSlice";
import statusSlice, { StatusState } from "./features/statusSlice";
import subscriberSlice, { ISubscriberState } from "./features/subscriberSlice";

export interface ReducerType {
  status: StatusState;
  auth: AuthState;
  report: IReportSlice;
  historyRoute: IHistorySlice;
  powerBi: IPowerBiSlice;
  payment: IPaymentSlice;
  subscriber: ISubscriberState;
  organization: IOrganizationSlice;
  setting: SettingState;
  post: IPostSlice;
}

const rootReducer = combineReducers({
  auth: authSlice,
  status: statusSlice,
  report: reportSlice,
  historyRoute: historyRouteSlice,
  powerBi: powerBiSlice,
  payment: paymentSlice,
  subscriber: subscriberSlice,
  organization: organizationSlice,
  setting: settingSlice,
  post: postSlice,
});

export const cobdsStore = () => {
  const store = configureStore({
    reducer: rootReducer,
  });
  return store;
};

export type AppStore = ReturnType<typeof cobdsStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
